import * as React from 'react';
import { Icon, InlineChildren, Text } from '@doordash/design-language';
import { MenuControlButton } from './styles';
import { Sizes } from './types/MenuTypes';

var MenuControl = function MenuControl(_ref) {
  var size = _ref.size,
      text = _ref.text,
      describedBy = _ref.describedBy,
      isExpanded = _ref.isExpanded,
      isInline = _ref.isInline,
      _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(MenuControlButton, {
    "aria-describedby": describedBy,
    "aria-haspopup": true,
    "aria-expanded": isExpanded,
    size: size,
    isExpanded: isExpanded,
    isInline: isInline,
    onClick: function onClick() {
      return _onClick && _onClick();
    }
  }, /*#__PURE__*/React.createElement(InlineChildren, {
    alignItems: InlineChildren.Alignment.Center,
    justifyContent: InlineChildren.Justification.SpaceBetween
  }, /*#__PURE__*/React.createElement(Text, {
    color: Text.Colors.FieldsForegroundInactive,
    styles: Text.Styles["Field".concat(size, "Input")],
    overflow: Text.Overflows.Truncate
  }, text), /*#__PURE__*/React.createElement(Icon, {
    color: Icon.Colors.FieldsForegroundInactive,
    type: isExpanded ? Icon.Types.ChevronUp : Icon.Types.ChevronDown,
    size: Icon.Sizes.Medium
  })));
};

MenuControl.Sizes = Sizes;
MenuControl.defaultProps = {
  size: MenuControl.Sizes.Medium,
  isInline: true
};
export default MenuControl;